import React, { useState, useMemo } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { LinkClickHandler } from './LinkClickHandler';

interface ExpandableHtmlContentProps {
  htmlContent: string;
  className?: string;
  /** Soglia di caratteri (testo senza HTML) oltre la quale comparire il toggle. Default 280. */
  threshold?: number;
  /** Altezza massima del contenuto collassato (classe tailwind). Default max-h-24 (6rem). */
  collapsedMaxHeight?: string;
  /** Colore del gradient di fade (tailwind from-X). Default sfondo card. */
  fadeFromClass?: string;
}

export const ExpandableHtmlContent: React.FC<ExpandableHtmlContentProps> = ({
  htmlContent,
  className = '',
  threshold = 280,
  collapsedMaxHeight = 'max-h-24',
  fadeFromClass = 'from-white dark:from-[#2F3437]',
}) => {
  const [expanded, setExpanded] = useState(false);

  const isLong = useMemo(
    () => htmlContent.replace(/<[^>]+>/g, '').trim().length > threshold,
    [htmlContent, threshold]
  );

  const truncated = isLong && !expanded;

  return (
    <div>
      <div className={`relative ${truncated ? `${collapsedMaxHeight} overflow-hidden` : ''}`}>
        <LinkClickHandler htmlContent={htmlContent} className={className} />
        {truncated && (
          <div
            className={`pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t ${fadeFromClass} to-transparent`}
          />
        )}
      </div>
      {isLong && (
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className="mt-1 inline-flex items-center gap-0.5 text-[11px] font-medium text-blue-600 dark:text-blue-400 hover:underline"
        >
          {expanded ? (
            <>
              <ChevronUp className="h-3 w-3" />
              Mostra meno
            </>
          ) : (
            <>
              <ChevronDown className="h-3 w-3" />
              Mostra di più
            </>
          )}
        </button>
      )}
    </div>
  );
};
